import { useQuery } from "@apollo/client"
import { debounce } from "lodash-es"
import React, { useState } from "react"
import { USERS } from "graphql/selector.queries.gql"
import StaticMultiSelector from "../../Atoms/StaticMultiSelector"
const UserMultipleSelector = ({ group, query, ...otherProps }) => {
  const [search, setQuery] = useState("")
  const { data } = useQuery(query, {
    variables: { group, first: 15, query: search },
  })

  const users = data?.usersByGroup

  function handleChange(srch) {
    if (srch !== search) setQuery(srch)
  }
  const debouncedChange = debounce(handleChange, 500)

  return (
    <StaticMultiSelector
      search={search}
      onSearchChange={debouncedChange}
      renderTag={item => item?.fullName}
      renderText={item => item?.fullName}
      searchBy={["fullName", "number"]}
      className="vt-user-selector"
      items={users ?? []}
      {...otherProps}
    />
  )
}

UserMultipleSelector.defaultProps = {
  query: USERS,
}
export default UserMultipleSelector
